<template>
    <section class="comp_overview_arrivals">
        <div class="comp_scroller">
            <div class="comp_content">
                <header class="wrp_comp_header mod--row mod--row-flex mod--row-middle mod--flex-column"
                        style="border-bottom: none; margin-bottom: 0.6rem">
                    <div style="display: flex">
                        <div :class="`col hideable ${searchActive?'hidden':''}`">
                            <div class="col">
                                <h1 class="part_ui_heading" v-bind:class="{'mod--hidden':searchActive}">
                                    <span>{{ $t('arrivals_remaining') }}: {{ countTodayRemaining }}</span></h1>
                            </div>
                            <div class="col">
                                <h2 class="part_ui_heading mod--subtitle" v-bind:class="{'mod--hidden':searchActive}">
                                    <span>{{ $t('arrivals_total') }}: {{ countTodayTotal }}</span>
                                </h2>
                            </div>
                        </div>
                        <form class="col mod--flex-grow col--search mod--right" v-on:submit="doSearch"
                              style="min-height: 43px;position: relative;display: flex;justify-content: flex-end;margin-bottom: 8px">
                            <input ref="search" type="text" v-model="search" :placeholder="$t('search')"
                                   v-bind:class="{'mod--active':searchActive}">
                            <button class="icon icon--search" style="margin-right: 8px;height: 43px"></button>
                        </form>
                    </div>
                    <div class="mod--row mod--row-flex mod--row-middle"
                         style="border-bottom: none; margin-bottom: 0">
                        <div class="col">
                            <div :class="`toggle-button ${!isToday()?'disabled':''}`"
                                 v-on:click="remainingOnly=!remainingOnly">
                                <img alt="" :src="require('../../assets/ON-small.svg')" v-if="remainingOnly"/>
                                <img alt="" :src="require('../../assets/OFF-small.svg')" v-else/>
                                <div class="label">{{ $t('remaining_only') }}</div>
                            </div>
                        </div>
                        <div class="col" style="flex: 1;align-items: flex-end">
                            <a class="help" v-on:click.prevent="showPopup(8233643603997)"
                               style="display:block">
                                <i class="icon icon--question-circle-fill"/>
                            </a>
                        </div>
                    </div>
                </header>
                <DateInputHeader v-model="date" :min-date="today"/>
                <div class="wrp_comp_body" :class="[loading ? 'state-loading' : '']"
                     v-on:scroll="handleGlobalScroll($event)">
                    <div class="mod--row mod--row-4" style="min-height: 100px">
                        <template v-if="reservations.length > 0">
                            <div class="col col--12" v-for="reservation in reservations">
                                <part-reservation :detailLink="(id,row) => {
                                                        if(reservation.is_current){
                                                            if(reservation.room_count_done >= reservation.room_count){
                                                                // TODO zatím takhle, do bydlícíhc nemohu odkazovat
                                                                return `/bookings/edit/${id}/${row}`
                                                            } else {
                                                                return `/overview/arrivals/${id}/${row}`
                                                            }
                                                        } else {
                                                            return `/bookings/edit/${id}/${row}`
                                                        }
                                                    }"
                                                  v-bind="reservation"/>
                            </div>
                        </template>
                        <div class="col col--12" v-else>
                            <p>{{ $t('nothing_found') }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import DateInputHeader from '../part/item/date_input_header';
import {fetchZenDesk, sanitize} from '../../main';

export default {
    name: 'overview-arrivals',
    components: {DateInputHeader},
    data() {
        return {
            loading: false,
            countTodayRemaining: null,
            countTodayTotal: null,
            reservations: [],
            search: '',
            searchActive: false,
            date: new Date(),
            remainingOnly: true
        }
    },
    computed: {
        today: {
            get() {
                return moment().startOf('day').toDate()
            }
        }
    },
    created() {
        this.getReservations();
    },
    watch: {
        date: function () {
            this.remainingOnly = this.isToday() // TODO opravdu má být disabled i v příjezdech?
            this.getReservations()
        },
        remainingOnly: function () {
            this.getReservations()
        }
    },
    methods: {
        doSearch: function (e) {
            e.preventDefault();
            if (this.searchActive === false) {
                this.searchActive = true;
                this.$nextTick(() => this.$refs.search.focus());
            } else {
                this.getReservations();
            }
        },
        getReservations: function () {
            this.loading = true;
            let self = this;
            let data = `
                    {
                        items {
                            id
                            name
                            note
                            is_group
                            created_at
                            reservation_rows {
                                id
                                reservation_number
                                check_in_date
                                check_out_date
                                guest_count
                                total_price_per_room
                                room_type_id
                                room_count
                                room_count_done
                                room_type {
                                    code
                                }
                                price_list {
                                    accommodation_currency {
                                        code_iso
                                    }
                                }
                                guests {
                                    profile {
                                        full_name
                                    }
                                    room {
                                        code
                                    }
                                    checked_in
                                }
                                canceled,
                                complete_profiles
                            }
                        },
                        pageInfo {
                            totalCount
                        }
                    }
                `;

            let query = `{
                    listReservations(check_in_date: "${moment(this.date).isSame(moment(), 'day') ? ':' : ''}${moment(this.date).format('YYYY-MM-DD')}", cancelled: false, valid: true, checked_in: null, order_by: "id|desc", search_anywhere: "%${sanitize(this.search)}%")
                    ${data}
                }`;

            axios({
                data: query
            }).then(response => {
                let reservations = [];

                this.countTodayRemaining = 0
                this.countTodayTotal = 0

                response.data.data.listReservations.items.forEach(function (item) {
                    item.reservation_rows.forEach(function (row) {
                        let reservation = {};
                        reservation.id = item.id;
                        reservation.row = row.id;
                        reservation.room = row.room_type.code;
                        reservation.price = row.total_price_per_room;
                        reservation.checkin_date = moment(row.check_in_date).format('D. M.');
                        reservation.checkout_date = moment(row.check_out_date).format('D. M.');
                        reservation.is_current = moment(row.check_in_date).isSameOrBefore(moment(), 'day')
                        reservation.guest_count = row.guest_count;
                        reservation.room_count = row.room_count;
                        reservation.room_count_done = row.room_count_done;
                        reservation.icons = [];
                        reservation.group = item.is_group;
                        reservation.currency = row.price_list.accommodation_currency.code_iso;
                        reservation.status = row.canceled ? 'canceled' : 'new';
                        reservation.full_name = item.name;
                        reservation.room_numbers = [];
                        reservation.checked_in_room_numbers = [];
                        reservation.precheckin_complete = row.complete_profiles >= row.guest_count

                        if (row.guests[0] && !item.name) {
                            reservation.full_name = row.guests[0].profile.full_name;
                        }

                        if (row.guests) {
                            row.guests.forEach(function (guest) {
                                if (guest.room) {
                                    reservation.room_numbers.push(guest.room.code);
                                    if (guest.checked_in && guest.room.code) {
                                        reservation.checked_in_room_numbers.push(guest.room.code);
                                    }
                                }
                            });

                            reservation.room_numbers = [...new Set(reservation.room_numbers)];
                            reservation.checked_in_room_numbers = [...new Set(reservation.checked_in_room_numbers)];
                        }

                        if (!row.canceled) {
                            self.countTodayRemaining += (row.room_count - row.room_count_done)
                            self.countTodayTotal += row.room_count
                        }

                        if (!self.remainingOnly || (row.room_count > row.room_count_done)) {
                            reservations.push(reservation);
                        }
                    });
                });

                this.reservations = reservations;
            }).catch(error => {
                this.showError(error)
            }).then(() => {
                this.loading = false;
            });
        },
        isToday: function () {
            return moment(this.date).isSame(moment(), 'day')
        },
        showPopup(articleId) { // FIXME udělat jako samostatnou komponentu a zobecnit i další prvky této obrazovky s ostatními
            fetchZenDesk(articleId)
                .then(article => {
                    let title;
                    let body;
                    if (article === 'not-found') {
                        title = 'Article not found'
                        body = 'Help is available for Czech or English. To display the help, change the language of the application in the settings.'
                    } else {
                        title = article.title
                        body = article.body
                    }

                    // FIXME udělat pořádně
                    const el = document.getElementById('popup');
                    el.innerHTML = '<div class=\'hint\'>' +
                        '<h2>' + title + '</h2>' +
                        body
                        +
                        '<button onclick=\'document.getElementById("popup").classList.remove("visible")\' class=\'close\'><span class="icon icon--x-circle-fill"></span></button>' +
                        '</div>'
                    el.classList.add('visible')
                })
        },
    }
}
</script>



// WEBPACK FOOTER //
// src/templates/comp/overview-arrivals.vue